'use client'

import { useState } from 'react'

/**
 * Mobile hamburger menu for the public navs. The desktop link row is
 * rendered separately (hidden below md); this renders the hamburger button
 * + a dropdown panel with the same links/actions on small screens. The
 * parent passes the mobile items as children (server-rendered links + the
 * client SignOutClient both work). Closes on any click inside the panel.
 */
export function MobileMenu({ children }: { children: React.ReactNode }) {
  const [open, setOpen] = useState(false)

  return (
    <div className="md:hidden ml-auto flex items-center">
      <button
        type="button"
        aria-label={open ? 'Close menu' : 'Open menu'}
        aria-expanded={open}
        onClick={() => setOpen((o) => !o)}
        className="p-2 -mr-1 text-text-1"
      >
        {open ? (
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
            <path d="M18 6 6 18M6 6l12 12" />
          </svg>
        ) : (
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
            <path d="M3 6h18M3 12h18M3 18h18" />
          </svg>
        )}
      </button>

      {open && (
        <div
          className="absolute left-0 right-0 top-full bg-[rgba(18,20,24,0.98)] backdrop-blur border-b border-[rgba(255,255,255,0.07)] px-4 py-4 flex flex-col gap-4"
          onClick={() => setOpen(false)}
        >
          {children}
        </div>
      )}
    </div>
  )
}
